import { useTranslation } from 'react-i18next';

const CompanyProfile = () => {
  const { t } = useTranslation();

  const infoItems = [
    { label: t('profile_company'), value: 'LAVSTYLE (CAMBODIA) INTERNATIONAL CO., LTD.' },
    {
      label: t('profile_address'),
      value: '#Borey Vimean Phnom Penh 86C, Street 9A, Phum Kdey Chas, Sangkat Bak Kheng, Khan Chrovchangva, Phnom Penh.',
    },
    {
      label: t('profile_phone'),
      value: '016 225 436',
      isLink: true,
      href: 'tel:+85516225436',
    },
    {
      label: t('profile_email'),
      value: 'mail@lavstyle.net',
      isLink: true,
      href: 'mailto:mail@lavstyle.net',
    },
    {
      label: t('profile_related'),
      value: '',
      isList: true,
      links: [
        { label: t('partner_3'), href: t('partner_3_url') },
        { label: t('partner_2'), href: t('partner_2_url') },
        { label: t('partner_1'), href: t('partner_1_url') },
      ],
    },
  ];

  return (
    <section id="profile" className="bg-navy-50 py-20 md:py-28" aria-labelledby="profile-heading">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-px bg-gold-400" aria-hidden="true"></span>
              <p className="text-gold-500 text-xs md:text-sm font-semibold tracking-[0.25em] uppercase">
                {t('profile_label')}
              </p>
            </div>
            <h2 id="profile-heading" className="text-2xl md:text-3xl lg:text-4xl font-bold text-navy-900 leading-tight mb-5">
              {t('profile_label')}
            </h2>
            <div className="w-12 h-0.5 bg-gold-400"></div>
          </div>

          <div className="lg:col-span-8 space-y-4 md:space-y-5" itemScope itemType="https://schema.org/Organization">
            <meta itemProp="name" content="LAVSTYLE (CAMBODIA) INTERNATIONAL CO., LTD." />
            {infoItems.map((item) => (
              <div
                key={item.label}
                className="bg-white rounded-sm p-6 md:p-7 border-l-4 border-gold-400"
              >
                <p className="text-xs md:text-sm font-semibold text-gold-500 uppercase tracking-[0.15em] mb-2">
                  {item.label}
                </p>
                {item.isList ? (
                  <ul className="space-y-1.5">
                    {item.links?.map((link) => (
                      <li key={link.label} className="text-sm md:text-base text-gray-700 flex items-center gap-2.5">
                        <span className="w-1.5 h-1.5 rounded-full bg-gold-400 flex-shrink-0"></span>
                        {link.href ? (
                          <a
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                            className="text-navy-800 font-medium hover:text-gold-600 hover:underline cursor-pointer transition-colors"
                          >
                            {link.label}
                          </a>
                        ) : (
                          <span className="text-gray-700">{link.label}</span>
                        )}
                      </li>
                    ))}
                  </ul>
                ) : item.isLink ? (
                  <a
                    href={item.href}
                    className="text-sm md:text-base text-navy-800 font-medium hover:text-gold-600 transition-colors cursor-pointer"
                    itemProp={item.label === t('profile_email') ? 'email' : item.label === t('profile_phone') ? 'telephone' : undefined}
                  >
                    {item.value}
                  </a>
                ) : item.label === t('profile_address') ? (
                  <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                    <p itemProp="streetAddress" className="text-sm md:text-base text-gray-700 leading-relaxed">{item.value}</p>
                    <meta itemProp="addressLocality" content="Phnom Penh" />
                    <meta itemProp="addressCountry" content="KH" />
                  </div>
                ) : (
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed">{item.value}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyProfile;
